import * as React from 'react';
import { classes, style } from 'typestyle';
import { windowBoxShadow } from '../window/Window';
import List from '../list/List';
const SelectMenu = ({ className, selectedId, children, onChange, }) => {
    return (React.createElement(List, { bordered: true, noLastItemBorder: true, className: classes('ta-select-list', selectItemsStyle, className) }, children &&
        React.Children.count(children) &&
        React.Children.map(children, (child) => {
            if (React.isValidElement(child) && child.props) {
                const { value } = child.props;
                const props = {
                    active: Boolean(selectedId && selectedId === value),
                    onClick: (val) => onChange(val),
                };
                return React.cloneElement(child, props);
            }
            return children;
        })));
};
export default SelectMenu;
const selectItemsStyle = style({
    padding: '4px 0',
    borderRadius: '12px',
    boxShadow: windowBoxShadow,
    overflow: 'hidden',
    maxHeight: 200,
    overflowY: 'auto',
});
//# sourceMappingURL=SelectMenu.js.map